<div class="flex align-center justify-start gap-10 p-10">
  <app-icon name="logout" size="lg" class="material-symbols-outlined icon"></app-icon>
  <h2 mat-dialog-title class="flex-1">Session Expiring</h2>
  @if (timer) {
    <h3 class="ml-auto">{{ timer }}</h3>
  }
</div>
<mat-dialog-content class="dialog-text">Your session will expire soon. Click OK to stay logged in.</mat-dialog-content>
<mat-dialog-actions align="end" class="mb-10">
  <button mat-flat-button class="primary-btn" [mat-dialog-close]="true" cdkFocusInitial>OK</button>
</mat-dialog-actions>
